import React from 'react'
import { useMutation } from '@apollo/client'
import { Trans, t } from '@lingui/macro'
import { EMAIL_ADDRESS_REGEX_WITH_TLD } from '@looop/graphql-scalars'
import { Link as RouterLink } from 'react-router-dom'
import { staticLinks } from 'shared/linkBuilder'
import { notification } from '../../components/common/notifications/Notifications'
import { apolloClientPublic } from '../../graphql/apolloClient'
import sendVerificationEmailMutation, {
  ISendVerificationEmailResponse,
  ISendVerificationEmailVariables
} from '../user/operations/public/sendVerificationEmailMutation'
import NotFound from '../../components/common/not-found/NotFound'
import { Spinner } from 'front-end/src/components'

import './Auth.less'
import Link from 'front-end/src/components/common/link/Link'
import { useOrganisation } from 'front-end/src/public-api/hooks/useOrganisation'

const AwaitingVerification = ({ match }) => {
  const { data: orgData, loading } = useOrganisation()

  const [sendVerificationEmail] = useMutation<
    ISendVerificationEmailResponse,
    ISendVerificationEmailVariables
  >(sendVerificationEmailMutation, {
    client: apolloClientPublic
  })

  if (loading) {
    return <Spinner />
  }

  const { id: orgId } = orgData?.organisation

  if (
    !match.params.email ||
    !match.params.email.match(EMAIL_ADDRESS_REGEX_WITH_TLD)
  ) {
    return (
      <div className="Auth">
        <div className="Auth__container">
          <NotFound
            message={t`Email is not valid, unable to verify user account.`}
          />
          <RouterLink to={staticLinks.login}>
            <Trans>Back to login page</Trans>
          </RouterLink>
        </div>
      </div>
    )
  }

  return (
    <div className="Auth">
      <div className="Auth__container">
        <h3>
          <Trans>Please verify your email address</Trans>
        </h3>
        <div className="Auth__text">
          <p>
            <Trans>
              Before we go any further we need to verify that you have access to
              the email address you used to sign up to Looop.
            </Trans>
          </p>
          <p>
            <Trans>
              An email has been sent to <strong>{match.params.email}</strong>.
            </Trans>
            <br />
            <Trans>Click on the link in the email to continue.</Trans>
          </p>
          <div className="verificationIcon">
            <span className="icon icon-envelope-letter icon-large" />
          </div>
        </div>
      </div>

      <p className="bottomLink">
        <Trans>Haven't received the email?</Trans>
        <br />
        <Link
          className="clickable"
          onClick={async () => {
            const { data } = await sendVerificationEmail({
              variables: {
                email: match.params.email,
                organisationId: orgId
              }
            })
            if (data) {
              const { type, message } = data.sendVerificationEmail
              if (type && message) {
                notification[type](message)
              } else {
                notification.error(t`Unable to resend verification email`)
              }
            }
          }}
        >
          <Trans>Resend the verification email</Trans>
        </Link>
      </p>
    </div>
  )
}

export default AwaitingVerification
